export const PRODUCT_PRICE_MULTIPLE_OF = 0.01;
export function getProductPrice(product) {
  var _product$fixedPriceOp;
  return (product == null || (_product$fixedPriceOp = product.fixedPriceOptions) == null ? void 0 : _product$fixedPriceOp.price) || '0';
}
//# sourceMappingURL=product-price.js.map